import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Translate from "helpers/Translate";

import { retryFileUpload } from "store/actions/fileAction";

function RetryUpload({ fileDoc }) {
  const dispatch = useDispatch();

  const retryUpload = fileDoc => {
    dispatch(retryFileUpload(fileDoc.id));
  };

  return (
    <div>
      <button
        data-tip={Translate({ id: "retry_upload" })}
        className="btn btn-default btn-sm center text-center"
        onClick={() => retryUpload(fileDoc)}
      >
        <i className="fas fa-sync fa-lg"></i>
      </button>
    </div>
  );
}

RetryUpload.propTypes = {
  fileDoc: PropTypes.object
};

export default RetryUpload;
